import { assignToTechnician } from "api/client/siteSurvey/assignToTechnician";
import { getSiteSurveyLink } from "api/client/siteSurvey/getSiteSurveyLink";
import { useRef, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useUniqueId } from "shared/uniqueId/useUniqueId";

interface AssignToTechModalType {
  surveyId: string;
  onHide: () => void;
}
export function AssignToTechModal({ surveyId, onHide }: AssignToTechModalType) {
  const [link, setLink] = useState("");
  const [isRunning, setIsRunning] = useState(false);
  const emailInputRef = useRef<HTMLInputElement>(null);
  const { uid } = useUniqueId("AssignToTechModal");

  async function handleSendEmail(e: React.MouseEvent<HTMLButtonElement>) {
    const email = emailInputRef.current?.value;
    if (!email) {
      onHide();
      return;
    }

    try {
      setIsRunning(true);
      await assignToTechnician({ request: { siteSurveyId: surveyId, technicianEmail: email } });
      onHide();
    } finally {
      setIsRunning(false);
    }
  }

  async function handleGetLinkClick() {
    const email = emailInputRef.current?.value;
    if (email) {
      try {
        setIsRunning(true);
        const { data } = await getSiteSurveyLink({
          request: { siteSurveyId: surveyId, technicianEmail: email },
        });
        setLink(data.link ?? "");
      } finally {
        setIsRunning(false);
      }
    }
  }
  return (
    <Modal aria-labelledby="contained-modal-title-vcenter" show centered onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Send the survey to technician</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3" controlId={uid("email")}>
          <Form.Label>Technician Email address</Form.Label>
          <Form.Control type="email" placeholder="name@example.com" autoFocus={true} ref={emailInputRef} />
        </Form.Group>

        {link && (
          <Form.Group className="mb-3" controlId={uid("email")}>
            <Form.Label>Link (You can copy this link and share it)</Form.Label>
            <Form.Control type="text" autoFocus={true} readOnly value={link} />
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-outline-primary" onClick={() => onHide()}>
          Close
        </button>
        <button className="btn btn-outline-primary" onClick={handleGetLinkClick} disabled={isRunning}>
          Get Link
        </button>

        <button className="btn btn-primary" onClick={handleSendEmail} disabled={isRunning}>
          Email Technician
        </button>
      </Modal.Footer>
    </Modal>
  );
}
